export const cache = (keyName, data) => {
  localStorage.setItem(keyName, Array.isArray(data) || typeof data === "object" ? JSON.stringify(data) : data);
};

export const cacheGet = (keyName, parse = true, defaultValue = null) => {
  const cachedData = localStorage.getItem(keyName);
  if(!cachedData)
    return defaultValue;
  return parse ? JSON.parse(cachedData) : cachedData;
};

export const cacheRemove = (keyName) => {
    localStorage.removeItem(keyName);
    return cacheGet(keyName, false);
};